<template>
  <div class="services">
    <h5 class="services__title">
      {{ this.title }}
    </h5>
    <ul class="services__ul">
      <li class="services__ul__li" v-for="(service, index) in services"
          :key="`${service.id}-${index}`">
        <div class="services__ul__li__service">
          <div class="services__ul__li__service__text">
            <span>{{ service.description }}</span>
            <div
              v-if="service.gm_price"
              class="services__ul__li__service__text__gm-price"
              v-html="$t('comparator.offers.offer.gmPrice', { price: service.gm_price })">
            </div>
          </div>
          <font-awesome-icon
            v-if="!notIcon"
            class="services__ul__li__service__icon"
            :icon="['fal', 'check-circle']" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'OfferServices',
  props: {
    services: {
      default: () => [],
      type: Array,
    },
    title: {
      default: '',
      type: String,
    },
    notIcon: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style scoped lang="scss">
.services {
  &__ul {
    margin-top: var(--nxt-space-xxxsmall);
    padding-left: 18px;
    font-size: 16px;
    &__li {
      &:nth-child(n + 2) {
        padding-top: 5px;
      }
      &__service {
        display: flex;
        align-items: center;
        justify-content: space-between;
        &__icon {
          margin-left: 5px;
          color: $--color-secondary;
        }
        &__text {
          &__gm-price {
            font-size: 13px;
          }
        }
      }
    }
  }
}
</style>
